<template>
  <div class="bank-information">
    <fieldset class="info-group">
      <legend>{{ $t("kyc.section.bankInformation") }}</legend>
    </fieldset>
    <fieldset :disabled="kycStatus=== 'submitted'?true:false">
      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('bankName'), 'valid': isFormFieldValid('bankName')}">
          <div class="input-group">
            <input id="bankNameInput"
                   name="bankName"
                   data-vv-as="Bank Name"
                   v-model="bankInformation.bankName"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="bankName">Bank Name：</label>
            <i class="bar"></i>
            <small v-show="errors.has('bankName')"
                   class="help text-danger">{{ errors.first('bankName') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('accountName'), 'valid': isFormFieldValid('accountName')}">
          <div class="input-group">
            <input id="accountNameInput"
                   name="accountName"
                   data-vv-as="Account Name"
                   v-model="bankInformation.accountName"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="accountName">Account Name：</label>
            <i class="bar"></i>
            <small v-show="errors.has('accountName')"
                   class="help text-danger">{{ errors.first('accountName') }}</small>
          </div>
        </div>
      </div>

      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('accountNumber'), 'valid': isFormFieldValid('accountNumber')}">
          <div class="input-group">
            <input id="accountNumberInput"
                   name="accountNumber"
                   data-vv-as="Beneficiary Number"
                   v-model="bankInformation.accountNumber"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="accountNumber">Beneficiary Number：</label>
            <i class="bar"></i>
            <small v-show="errors.has('accountNumber')"
                   class="help text-danger">{{ errors.first('accountNumber') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('bankAddress'), 'valid': isFormFieldValid('bankAddress')}">
          <div class="input-group">
            <input id="bankAddressInput"
                   name="bankAddress"
                   data-vv-as="Bank Address"
                   v-model="bankInformation.bankAddress"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="bankAddress">Bank Address：</label>
            <i class="bar"></i>
            <small v-show="errors.has('bankAddress')"
                   class="help text-danger">{{ errors.first('bankAddress') }}</small>
          </div>
        </div>
      </div>

      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('swift'), 'valid': isFormFieldValid('swift')}">
          <div class="input-group">
            <input id="swiftInput"
                   name="swift"
                   data-vv-as="SWIFT"
                   v-model="bankInformation.swift"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="swift">SWIFT：</label>
            <i class="bar"></i>
            <small v-show="errors.has('swift')"
                   class="help text-danger">{{ errors.first('swift') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('iban'), 'valid': isFormFieldValid('iban')}">
          <div class="input-group">
            <input id="ibanInput"
                   name="iban"
                   data-vv-as="IBAN"
                   v-model="bankInformation.iban"
                   autocomplete="off"
                   required  />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="iban">IBAN(Mandatory for European Countries)：</label><!-- Mandatory -->
            <i class="bar"></i>
            <small v-show="errors.has('iban')"
                   class="help text-danger">{{ errors.first('iban') }}</small>
          </div>
        </div>
      </div>

      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('bsbNumber'), 'valid': isFormFieldValid('bsbNumber')}">
          <div class="input-group">
            <input id="bsbNumberInput"
                   name="bsbNumber"
                   data-vv-as="bsbNumber"
                   v-model="bankInformation.bsbNumber"
                   autocomplete="off"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="bsbNumber">BSB Number(Mandatory for Australia)：</label>
            <i class="bar"></i>
            <small v-show="errors.has('bsbNumber')"
                   class="help text-danger">{{ errors.first('bsbNumber') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('aba'), 'valid': isFormFieldValid('aba')}">
          <div class="input-group">
            <input id="abaInput"
                   name="aba"
                   data-vv-as="aba"
                   v-model="bankInformation.aba"
                   autocomplete="off"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="aba">ABA(Routing Number, Mandatory for U.S.)：</label>
            <i class="bar"></i>
            <small v-show="errors.has('aba')"
                   class="help text-danger">{{ errors.first('aba') }}</small>
          </div>
        </div>
      </div>
    </fieldset>
  </div>

</template>
<script>
import mixin from '../mixins/mixin'
export default {
  mixins: [mixin],
  props: {
    kycStatus: {
      type: String,
      default: '',
    },
    merchantData: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      bankInformation: {
        bankName: '',
        accountName: '',
        accountNumber: '',
        bankAddress: '',
        swift: '',
        iban: '',
        bsbNumber: '',
        aba: '',
      },
    }
  },
  mounted () {
    let that = this
    if (that.kycStatus === 'firstEdit') {
      that.getMerchantKYCInfo(5, res => {
        that.setBankInfo(res.bank_info)
      })
    } else if (that.merchantData.bank_info) {
      that.setBankInfo(that.merchantData.bank_info)
    } else {}
  },
  methods: {
    setBankInfo (info) {
      if (!info) return
      this.bankInformation.bankName = info.bank_name
      this.bankInformation.accountName = info.account_name
      this.bankInformation.accountNumber = info.account_number
      this.bankInformation.bankAddress = info.bank_address
      this.bankInformation.swift = info.swift
      this.bankInformation.iban = info.iban
      this.bankInformation.bsbNumber = info.bsb_number
      this.bankInformation.aba = info.aba
    },
    saveBankInfo (cb) {
      let that = this
      that.$validator.validateAll(that.bankInformation).then((result) => {
        if (result) {
          let params = {
            page: 5,
            bank_info: {
              'aba': that.bankInformation.aba,
              'account_name': that.bankInformation.accountName,
              'account_number': that.bankInformation.accountNumber,
              'bsb_number': that.bankInformation.bsbNumber,
              'bank_address': that.bankInformation.bankAddress,
              'bank_name': that.bankInformation.bankName,
              'iban': that.bankInformation.iban,
              'swift': that.bankInformation.swift
            }
          }
          that.$emit('updateKycInformation', params, function () {
            let flag = true
            cb(flag)
          })
        } else {
          let flag = false
          cb(flag)
        }
      })
    },
    getBankInfo (cb) {
      let that = this
      let bankInfo = new Promise((resolve, reject) => {
        that.$validator.validateAll(that.bankInformation).then((result) => {
          if (result) {
            let params = {
              bank_info: {
                'aba': that.bankInformation.aba,
                'account_name': that.bankInformation.accountName,
                'account_number': that.bankInformation.accountNumber,
                'bsb_number': that.bankInformation.bsbNumber,
                'bank_address': that.bankInformation.bankAddress,
                'bank_name': that.bankInformation.bankName,
                'iban': that.bankInformation.iban,
                'swift': that.bankInformation.swift
              }
            }
            resolve(params)
          } else {
            this.$message({
              type: 'warn',
              message: 'Please fill in Bank Information'
            })
          }
        })
      })
      return bankInfo
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
  },
}
</script>
<style lang="scss" scoped>
.bank-information {
  width: 100%;
  .form-group {
    width: 100%;
  }
  /deep/ .select-form-group {
    margin-bottom: 0;
  }
  /deep/ .vuestic-scrollbar {
    overflow-y: scroll;
  }
}
</style>
